import { clearStudent } from "../actions/common/student";
import SchoolNavi from "../components/features/Navigation/SchoolNavi";
import { useNavigationToggle } from "../contexts/NavigationContext";
import { withRouter } from "../helpers/RouterHelper";
import {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../hocs/enhanceAuthenticatedPage";

export interface SidebarProps
  extends AuthenticatedPageProps,
    AuthenticatedPageCallbacks {
  clearStudent: typeof clearStudent;
  activeMenu: string;
}

const SectionSidebar = (props: SidebarProps) => {
  const { isNavigationOpen } = useNavigationToggle();

  if (!props.currentSection.data || !props.currentOperator) {
    return null;
  }

  return (
    <SchoolNavi
      {...props}
      section={props.currentSection.data}
      privileges={props.operatorPrivileges.data?.privileges}
      opened={isNavigationOpen}
    />
  );
};

export default withRouter<SidebarProps>(SectionSidebar);
